import ApplicationConfig from '@/lib/application-config'
import connectHttpBase from '@/lib/connect-client/connect-http-base'

const V1_STRIPE = '/v1/stripe'
const V1_PAY = '/v1/pay'
const V1_MARKET_MONITOR = '/v1/market-monitor'

class ConnectPayClient {
  constructor() {
    this.refreshTokenDaemonStarted = false
  }

  endpoint(path) {
    return ApplicationConfig.getPayServer() + path
  }

  listBillingPlans() {
    const endpoint = this.endpoint(V1_STRIPE + '/plans')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  getStripeInfo() {
    const endpoint = this.endpoint(V1_STRIPE + '/info')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  listStripeCoupons() {
    const endpoint = this.endpoint(V1_STRIPE + '/coupons')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  subscribeStripePlan(request) {
    const endpoint = this.endpoint(V1_STRIPE + '/subscription')
    return connectHttpBase.getAuthenticatedHttpClient().post(endpoint, request)
  }

  getPurchaseInfo() {
    const endpoint = this.endpoint(V1_PAY + '/purchases')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  updateCustomerName(request) {
    const endpoint = this.endpoint(V1_STRIPE + '/customer/name')
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint, request)
  }

  updateCustomerEmail(request) {
    const endpoint = this.endpoint(V1_STRIPE + '/customer/email')
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint, request)
  }

  unsubscribeStripe(params) {
    const endpoint = this.endpoint(V1_STRIPE + '/subscriptions/' + params.subscriptionId)
    return connectHttpBase.getAuthenticatedHttpClient().post(endpoint)
  }

  selectStripeCreditCard(params) {
    const endpoint = this.endpoint(V1_STRIPE + '/card/' + params.card.id)
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint)
  }

  deleteStripeCreditCard(params) {
    const endpoint = this.endpoint(V1_STRIPE + '/card/' + params.card.id)
    return connectHttpBase.getAuthenticatedHttpClient().delete(endpoint, params.userInfo)
  }

  addStripeCreditCard(addCardRequest) {
    const endpoint = this.endpoint(V1_STRIPE + '/card')
    return connectHttpBase.getAuthenticatedHttpClient().post(endpoint, addCardRequest)
  }

  changeStripePlan(request) {
    const endpoint = this.endpoint(V1_STRIPE + '/subscriptions/' + request.subscriptionId + '/' + request.planId)
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint)
  }

  changePaymentMethodTypes(params) {
    const request = {
      addCardRequest: params.addCardRequest,
    }
    const endpoint = this.endpoint(
      V1_STRIPE + '/subscriptions/payment_method/' + params.subscriptionId + '/' + params.paymentMethodTypes
    )
    return connectHttpBase.getAuthenticatedHttpClient().put(endpoint, params.addCardRequest)
  }

  getMarketMonitorAccessToken() {
    const endpoint = this.endpoint(V1_MARKET_MONITOR + '/access-token')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }

  getFeedAccessToken() {
    const endpoint = this.endpoint(V1_MARKET_MONITOR + '/feed-access-token')
    return connectHttpBase.getAuthenticatedHttpClient().get(endpoint)
  }
}

const connectPayClient = new ConnectPayClient()
export default connectPayClient
